export default "__VITE_ASSET__BHKuxMA3__"